import React from 'react'
import {
  Box,
  Card,
  Heading,
  SimpleGrid,
  Text,
  VStack
} from '@chakra-ui/react'
import { useOnboarding } from '../../contexts/OnboardingContext'

export const CreativeSummary: React.FC = () => {
  const { generated_assets, basic_info } = useOnboarding()

  const selectedCarousel = generated_assets?.carousel_candidates?.[0]
  const landingPage = generated_assets?.landing_page
  const ctaType = landingPage?.cta_config?.cta_type || 'book_call'

  return (
    <Card.Root borderColor="brand.200" bg="brand.50" w="full" borderWidth="2px">
      <Card.Body p={{ base: 5, md: 6 }}>
        <VStack gap={4} align="stretch" textAlign="left">
          <Heading size="md" color="gray.900">
            What you've created
          </Heading>
          <Text fontSize="sm" color="gray.700">
            Review what you've created, then select a visibility pack to activate your carousel ads.
          </Text>
          <SimpleGrid columns={{ base: 1, md: 3 }} gap={4}>
            <Box>
              <Text fontSize="xs" color="gray.500" fontWeight="semibold" mb={2}>
                Your Carousel
              </Text>
              <Text fontSize="sm" color="gray.800" mb={1}>
                <Text as="span" fontWeight="semibold">Template:</Text>{' '}
                {selectedCarousel?.template_name || 'Transformation Story'}
              </Text>
              <Text fontSize="sm" color="gray.800" mb={1}>
                <Text as="span" fontWeight="semibold">Slides:</Text>{' '}
                {selectedCarousel?.slides?.length || 4}-
                {selectedCarousel?.slides?.length || 7} slides
              </Text>
              <Text fontSize="sm" color="gray.800">
                <Text as="span" fontWeight="semibold">Message:</Text>{' '}
                {selectedCarousel?.primary_message || 'Transformation'}
              </Text>
            </Box>
            <Box>
              <Text fontSize="xs" color="gray.500" fontWeight="semibold" mb={2}>
                Your Landing Page
              </Text>
              <Text fontSize="sm" color="gray.800" mb={1}>
                <Text as="span" fontWeight="semibold">CTA Type:</Text>{' '}
                {ctaType === 'ask_question' ? 'Ask a Question' : 'Book a Call'}
              </Text>
              <Text fontSize="sm" color="gray.800" mb={1}>
                <Text as="span" fontWeight="semibold">Destination:</Text> Spotlight page
              </Text>
              <Text fontSize="sm" color="gray.800">
                <Text as="span" fontWeight="semibold">Status:</Text> Ready to launch
              </Text>
            </Box>
            <Box>
              <Text fontSize="xs" color="gray.500" fontWeight="semibold" mb={2}>
                After Payment
              </Text>
              <Text fontSize="sm" color="gray.700" mb={1}>
                • Confirm your booking preferences
              </Text>
              <Text fontSize="sm" color="gray.700" mb={1}>
                • Ads launch automatically on your selected platforms
              </Text>
              <Text fontSize="sm" color="gray.700">
                • Track results in your dashboard
              </Text>
            </Box>
          </SimpleGrid>
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}



